<template>
  <div class="timepicker-wrapper">
    <div class="input-material">
      <input type="number" placeholder="." value="10:00" />
      <label>Set Start Time</label>
    </div>

    <div class="timepicker-box">
      <header class="timepicker-header">
        <input
          max="12"
          min="1"
          type="number"
          v-on:focus="onFocusHour()"
          :value="selected.hour"
        />
        <span class="px-1">:</span>
        <input
          type="number"
          max="60"
          min="0"
          v-on:focus="onFocusMinutes()"
          :value="
            selected.minutes < 10 ? '0' + selected.minutes : selected.minutes
          "
        />
        <div class="t-selector">
          <button class="t-selected">AM</button>
          <button>PM</button>
        </div>
      </header>
      <section class="timepicker-clockbox">
        <!-- HOUR CLOCK DIAL -->
        <div v-if="hourDial">
          <div class="clock-dial">
            <div
              class="clock-selector"
              :style="{ transform: `rotate(${selected.hours_deg}deg)` }"
            ></div>
            <div class="clock-center-point"></div>
            <div class="timepicker-hours">
              <div
                class="hour"
                @click="onSelectHours(1, '30')"
                :class="selected.hour == 1 ? 'selected' : ''"
                style="top: 15px;right: 50px;"
                >1</div
              >
              <div
                class="hour"
                @click="onSelectHours(2, '60')"
                :class="selected.hour == 2 ? 'selected' : ''"
                style="top: 50px;right: 15px;"
                >2</div
              >
              <div
                class="hour"
                @click="onSelectHours(3, '90')"
                :class="selected.hour == 3 ? 'selected' : ''"
                style="top:calc(50% - 15px);right:0;"
                >3</div
              >
              <div
                class="hour"
                @click="onSelectHours(4, '120')"
                :class="selected.hour == 4 ? 'selected' : ''"
                style="bottom: 50px; right: 15px;"
                >4</div
              >
              <div
                class="hour"
                @click="onSelectHours(5, '150')"
                :class="selected.hour == 5 ? 'selected' : ''"
                style="bottom: 15px;right: 50px;"
                >5</div
              >
              <div
                class="hour"
                @click="onSelectHours(6, '180')"
                :class="selected.hour == 6 ? 'selected' : ''"
                style="bottom:0;left:calc(50% - 15px);"
                >6</div
              >
              <div
                class="hour"
                @click="onSelectHours(7, '210')"
                :class="selected.hour == 7 ? 'selected' : ''"
                style="left: 50px; bottom: 15px;"
                >7</div
              >
              <div
                class="hour"
                @click="onSelectHours(8, '240')"
                :class="selected.hour == 8 ? 'selected' : ''"
                style="left: 15px; bottom: 50px;"
                >8</div
              >
              <div
                class="hour"
                @click="onSelectHours(9, '270')"
                :class="selected.hour == 9 ? 'selected' : ''"
                style="top:calc(50% - 15px);left:0;"
                >9</div
              >
              <div
                class="hour"
                @click="onSelectHours(10, '300')"
                :class="selected.hour == 10 ? 'selected' : ''"
                style="top: 50px; left: 15px;"
                >10</div
              >
              <div
                class="hour"
                @click="onSelectHours(11, '330')"
                :class="selected.hour == 11 ? 'selected' : ''"
                style="top: 15px; left: 50px;"
                >11</div
              >
              <div
                class="hour"
                @click="onSelectHours(12, '360')"
                :class="selected.hour == 12 ? 'selected' : ''"
                style="top:0;left:calc(50% - 15px);"
                >12</div
              >
            </div>
          </div>
        </div>

        <!-- MINUTE CLOCK DIAL -->
        <div v-if="minutesDial">
          <div class="clock-dial">
            <div
              class="clock-selector"
              :style="{ transform: `rotate(${selected.mintues_deg}deg)` }"
            ></div>
            <div class="clock-center-point"></div>
            <div class="timepicker-minutes-wrapper">
              <div
                class="timepicker-minutes"
                @click="onSelectMintue(5, 30)"
                :class="selected.minutes == 5 ? 'selected' : ''"
                style="top: 15px;right: 50px;"
                >5</div
              >
              <div
                class="timepicker-minutes"
                @click="onSelectMintue(10, 60)"
                :class="selected.minutes == 10 ? 'selected' : ''"
                style="top: 50px;right: 15px;"
                >10</div
              >
              <div
                class="timepicker-minutes"
                @click="onSelectMintue(15, 90)"
                :class="selected.minutes == 15 ? 'selected' : ''"
                style="top:calc(50% - 15px);right:0;"
                >15</div
              >
              <div
                class="timepicker-minutes"
                @click="onSelectMintue(20, 120)"
                :class="selected.minutes == 20 ? 'selected' : ''"
                style="bottom: 50px; right: 15px;"
                >20</div
              >
              <div
                class="timepicker-minutes"
                @click="onSelectMintue(25, 150)"
                :class="selected.minutes == 25 ? 'selected' : ''"
                style="bottom: 15px; right: 50px;"
                >25</div
              >
              <div
                class="timepicker-minutes"
                @click="onSelectMintue(30, 180)"
                :class="selected.minutes == 30 ? 'selected' : ''"
                style="bottom:0;left:calc(50% - 15px);"
                >30</div
              >
              <div
                class="timepicker-minutes"
                @click="onSelectMintue(35, 210)"
                :class="selected.minutes == 35 ? 'selected' : ''"
                style="left: 50px; bottom: 15px;"
                >35</div
              >
              <div
                class="timepicker-minutes"
                @click="onSelectMintue(40, 240)"
                :class="selected.minutes == 40 ? 'selected' : ''"
                style="left: 15px; bottom: 50px;"
                >40</div
              >
              <div
                class="timepicker-minutes"
                @click="onSelectMintue(45, 270)"
                :class="selected.minutes == 45 ? 'selected' : ''"
                style="top:calc(50% - 15px);left:0;"
                >45</div
              >
              <div
                class="timepicker-minutes"
                @click="onSelectMintue(50, 300)"
                :class="selected.minutes == 50 ? 'selected' : ''"
                style="top: 50px; left: 15px;"
                >50</div
              >
              <div
                class="timepicker-minutes"
                @click="onSelectMintue(55, 330)"
                :class="selected.minutes == 55 ? 'selected' : ''"
                style="top: 15px; left: 50px;"
                >55</div
              >
              <div
                class="timepicker-minutes"
                @click="onSelectMintue(0, 360)"
                :class="selected.minutes == 0 ? 'selected' : ''"
                style="top:0;left:calc(50% - 15px);"
                >00</div
              >
            </div>
          </div>
        </div>
      </section>
      <footer class="timepicker-footer">
        <button>CANCEL</button>
        <button>OK</button>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        selected: {
          hour: 12,
          minutes: 0,
          hours_deg: 360,
          minutes_deg: 360,
        },
        hourDial: true,
        minutesDial: false,
      };
    },
    methods: {
      onFocusHour: function() {
        this.hourDial = true;
        this.minutesDial = false;
      },

      onFocusMinutes: function() {
        this.hourDial = false;
        this.minutesDial = true;
      },

      onSelectHours: function(hour, deg) {
        this.selected.hour = hour;
        this.selected.hours_deg = deg;
        setTimeout(() => {
          this.onFocusMinutes();
        }, 400);
      },

      onSelectMintue: function(mintues, deg) {
        this.selected.minutes = mintues;
        this.selected.mintues_deg = deg;
      },
    },
  };
</script>

<style>
  .timepicker-wrapper {
    position: relative;
  }

  .timepicker-box {
    left: 0;
    top: 55px;
    overflow: hidden;
    min-width: 300px;
    position: absolute;
    border-radius: 3px;
    background-color: #fff;
    z-index: 999;
    box-shadow: 0 0.75rem 2.25rem 1rem rgba(0, 0, 0, 0.24);
  }

  .timepicker-header {
    padding: 15px;
    text-align: center;
    position: relative;
    user-select: none;
    background-color: #fff;
  }

  .timepicker-header input {
    width: 60px;
    height: 50px;
    border: none;
    color: #fff;
    font-size: 40px;
    border-radius: 5px;
    user-select: none;
    text-align: center;
    background-color: transparent;
  }

  .timepicker-header span {
    top: -3px;
    color: #fff;
    line-height: 1;
    font-size: 40px;
    position: relative;
  }

  .timepicker-header input:focus {
    background-color: rgba(225, 225, 225, 0.3);
  }

  .t-selector {
    position: absolute;
    right: 15px;
    top: calc(50% - 28.5px);
  }

  .t-selector button {
    margin: 5px;
    border: none;
    color: #fff;
    display: block;
    font-size: 13px;
    font-weight: normal;
    border-radius: 2px;
    letter-spacing: 1px;
    transition: 0.2s ease-in;
    background-color: transparent;
  }

  .t-selector button:hover {
    background-color: rgba(225, 225, 225, 0.3);
  }
  .t-selector button.t-selected {
    columns: grey;
    font-weight: bold;
    background-color: rgba(225, 225, 225, 0.3);
  }

  .timepicker-clockbox {
    padding: 30px 15px 25px 15px;
  }

  .clock-dial {
    width: 225px;
    height: 225px;
    margin: 0 auto;
    position: relative;
    border-radius: 50%;
    transition: 0.5s;
    animation: fadeIn 0.5s;
    background-color: #d3d3d382;
    box-shadow: 1px 1px 5px 1px #808080ab;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.75);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .clock-center-point {
    width: 5px;
    height: 5px;
    z-index: 111;
    user-select: none;
    border-radius: 50%;
    position: absolute;
    top: calc(50% - 2.5px);
    left: calc(50% - 2.5px);
    background-color: #fff;
  }

  .clock-selector {
    height: 83px;
    width: 3px;
    z-index: 999;
    display: block;
    position: absolute;
    left: calc(50% - 1px);
    bottom: calc(50% - 1px);
    transform: rotate(45deg);
    transform-origin: bottom center;
    background-color: #fff;
  }

  .timepicker-hours .hour,
  .timepicker-minutes-wrapper .timepicker-minutes {
    width: 30px;
    height: 30px;
    display: flex;
    line-height: 0.75;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    text-align: center;
    position: absolute;
    align-items: center;
    justify-content: center;
  }

  .timepicker-minutes-wrapper .timepicker-minutes {
    font-size: 15px;
  }

  .timepicker-hours .hour.selected,
  .timepicker-minutes.selected {
    color: #fff;
    border-radius: 50%;
    font-weight: normal;
    background-color: #3876d2bd;
  }

  .timepicker-footer {
    padding: 10px;
    text-align: right;
    background-color: #fff;
  }

  .timepicker-footer button {
    border: none;
    font-size: 14px;
    min-width: 70px;
    border-radius: 3px;
    padding: 5px 10px;
    color: var(--lightgrey);
    font-weight: 600;
    letter-spacing: 1px;
    background-color: transparent;
  }

  .timepicker-footer button:hover {
    background-color: #d3d3d3;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/materialTimePicker.vue